import * as React from "react"


export default (props:any) => {
    const descStr = props.description.substr(0, 100)+'...';
    return(
        <div className="boxTabs__content" onClick={() => props.openModal(props)}>
            <div className="img">
                <img src={props.imgUrl.url} alt={props.imgUrl.alt} title={props.imgUrl.alt}/>
            </div>
            <div className="title">{props.title}</div>
            <div className="desc">{descStr}</div>
        </div>
    )
}